import { FC, useEffect } from "react";
import { useSelector } from "react-redux";

import { Info, Tooltip } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { useAgentFlag } from "hooks/use-agent-flag";
import { selectIsViewer } from "store/entities/agents";
import { selectIsKbWidgetPreinstalled } from "store/entities/license";

import { StyledWidget } from "./styles";

interface IProps {
  isSelected: boolean;
  onClick: () => void;
  iconUrl?: string;
  className?: string;
}

export const KbWidgetIcon: FC<IProps> = ({ isSelected, onClick, iconUrl, className }) => {
  const isKbWidgetPreinstalled = useSelector(selectIsKbWidgetPreinstalled);
  const isViewer = useSelector(selectIsViewer);
  const [tooltipAlreadyClosed, setTooltipAsClosed] = useAgentFlag("preinstalledKbWidgetTooltipClosed");

  const shouldDisplayTooltip = isKbWidgetPreinstalled && !tooltipAlreadyClosed && !isViewer;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const setTooltipAsSeen = () => {
    if (shouldDisplayTooltip) {
      setTooltipAsClosed(true);
    }
  };

  useEffect(() => {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => setTooltipAsSeen();
  }, []);

  return (
    <Tooltip
      kind="invert"
      placement="left"
      isVisible={shouldDisplayTooltip}
      offsetMainAxis={14}
      triggerRenderer={
        <StyledWidget isSelected={isSelected} onClick={onClick} iconUrl={iconUrl} className={className} />
      }
    >
      <Block width="240px">
        <Info
          theme="invert"
          closeWithX
          handleCloseAction={setTooltipAsSeen}
          text="Access KnowledgeBase articles to reliably and quickly respond to tickets."
        />
      </Block>
    </Tooltip>
  );
};
